import React from "react";
import { useTranslation } from "react-i18next";

import closeIcon from "../../assets/close.png";

import styles from "./Modal.module.css";

const Modal = ({
	isOpen,
	onClose,
	title,
	subtitle = null,
	points = null,
	children,
	containerClassName = "",
	containerStyle = {},
	hideCloseButton = false,
}) => {
	const { t } = useTranslation();

	if (!isOpen) return null;

	return (
		<div className={styles.background} onClick={onClose}>
			<div className={`${styles.container} ${containerClassName}`} style={containerStyle} onClick={(e) => e.stopPropagation()}>
				{!hideCloseButton && <img src={closeIcon} className={styles.closeButton} onClick={onClose} alt="close-icon" />}
				{title && <div className={styles.title}>{title}</div>}
				{subtitle && (
					<div className={styles.subtitle}>
						<span>{subtitle}</span>
						{points && <span className={styles.points}>{t("common.modal.pointsFormat", { points })}</span>}
					</div>
				)}
				{children}
			</div>
		</div>
	);
};

export default Modal;
